// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/scss/workflow/workflow-base.scss
// module id = 190
// module chunks = 50